import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

/**
 * ProductIdentification Partial Translation Cell
 * Translates productIdentification Enum into relevant strings
 */
export const productIdentificationPartial: Columns<any> = {
  title: 'table.productidentification.title',
  key: 'productIdentification',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    'tariff': 'enum.meteringpoint.productcharacteristic.tariff',
    'fuelquantity': 'enum.meteringpoint.productcharacteristic.fuelquantity',
    'poweractive': 'enum.meteringpoint.productcharacteristic.poweractive',
    'powerreactive': 'enum.meteringpoint.productcharacteristic.powerreactive',
    'energyactive': 'enum.meteringpoint.productcharacteristic.energyactive',
    'energyreactive': 'enum.meteringpoint.productcharacteristic.energyreactive',
    'notspecified': 'enum.meteringpoint.productcharacteristic.notspecified'
  }
}
